import { defineMessages } from 'react-intl';

/** Shared i18n for Rudo publish/settings fields. */
export const rudoMessages = defineMessages({
  folderLabel: {
    id: 'socialExport.rudo.folder.label',
    defaultMessage: 'Carpeta',
  },
  folderHelper: {
    id: 'socialExport.rudo.folder.helper',
    defaultMessage: 'Carpeta de destino en Rudo',
  },
  folderNoOptions: {
    id: 'socialExport.rudo.folder.noOptions',
    defaultMessage: 'No hay carpetas disponibles',
  },
  createFolder: {
    id: 'socialExport.rudo.folder.create',
    defaultMessage: 'Crear carpeta',
  },
  createFolderTitle: {
    id: 'socialExport.rudo.folder.createTitle',
    defaultMessage: 'Nueva carpeta',
  },
  createFolderName: {
    id: 'socialExport.rudo.folder.name',
    defaultMessage: 'Nombre de la carpeta',
  },
  createFolderSubmit: {
    id: 'socialExport.rudo.folder.createSubmit',
    defaultMessage: 'Crear',
  },
  createFolderCancel: {
    id: 'socialExport.rudo.folder.createCancel',
    defaultMessage: 'Cancelar',
  },
  createFolderSuccess: {
    id: 'socialExport.rudo.folder.createSuccess',
    defaultMessage: 'Carpeta creada',
  },
  restrictionLabel: {
    id: 'socialExport.rudo.restriction.label',
    defaultMessage: 'Restricción VOD',
  },
  restrictionNone: {
    id: 'socialExport.rudo.restriction.none',
    defaultMessage: 'Sin restricción',
  },
  restrictionPremium: {
    id: 'socialExport.rudo.restriction.premium',
    defaultMessage: 'Premium',
  },
  restrictionRegistration: {
    id: 'socialExport.rudo.restriction.registration',
    defaultMessage: 'Solo registrados',
  },
});
